import { Component, inject, signal } from '@angular/core';
import { NetworkService } from '@core/services/network.service';
import { NttButton } from '@ui/button';

@Component({
  selector: 'ntt-offline',
  templateUrl: './offline.html',
  styleUrl: './offline.scss',
  imports: [NttButton],
})
export class OfflineComponent {
  private readonly _network = inject(NetworkService);
  readonly checking = signal(false);
  readonly failed = signal(false);

  async retry(): Promise<void> {
    if (this.checking()) return;

    this.checking.set(true);
    this.failed.set(false);
    try {
      this.failed.set(!(await this._network.check()));
    } finally {
      this.checking.set(false);
    }
  }
}
